/**
 * Название системы (UI-2): продукт — ROXBER ERP, CCPM — модуль внутри него.
 * В статическом index.html (шаблон frontend/index.html) то же название вписано текстом.
 */
export const BRAND = 'ROXBER ERP';
